import { DateTime } from 'luxon';
import React, { useEffect, useRef } from 'react'
import { ReactComponent as Check } from "../../../assets/new-icons/check_simple.svg";

function CardMonth({data, indexBar, index}) {

    return (
        <div className={index === indexBar ? `month_card check` : `month_card`}>
            <div className="month_card-top">
                <div className="month_card-top_icon">{data.tipo === 'R' ? <Check /> : null}</div>
                <p className="month_card-top_label">{DateTime.fromISO(data.datamisura).toFormat('dd.MM.yy')}</p>
            </div>
            <div className="month_card-middle">
                <div className="month_card-middle_box">
                    <div className="month_card-middle_box-label">Prezzo</div>
                    <div className="month_card-middle_box-main">{parseFloat(data.qv).toFixed(2).replace(/\./g, ",")} €</div>
                </div>
                <div className="month_card-middle_box">
                    <div className="month_card-middle_box-label">kWh</div>
                    <div className="month_card-middle_box-main">{parseFloat(data.kwh_tot).toFixed(2).replace(/\./g, ",")}</div>
                </div>
            </div>
            <div className="month_card-bottom">
                <p className="month_card-bottom_label">Consumi</p>
                <p className="month_card-bottom_main">{parseFloat(data.spesa_giorno).toFixed(2).replace(/\./g, ",")}€</p>
            </div>
        </div>
    )
}

export default CardMonth